<template>
	<el-dialog title="使用须知" :visible.sync="dialogVisible" :close-on-click-modal="false" class="warn-dialog-warn notice-for-use" append-to-body width="670px">
		<div class="reading-main clear">
			<p>
				在使用该方案之前，请您务必留意：
				该方案内所有图片（包括但不限于广告图、产品图、人物图）、文案仅作为示例展示，著作权归本平台或相关合法权利人所有，您在基于本平台场景下有权使用该方案，但图片、文案等其他资料，您均应自行准备替换，并保证不存在任何违法及侵犯第三方知识产权的情况；若您希望使用该方案中的任何图片、文案或其他资料，请另行与其合法权利人进行联系并取得其使用授权。本平台对于您因擅自使用方案中的文案或图片而导致的纠纷和追责不承担任何责任。
			</p>
			<el-checkbox v-model="readCheck">已阅读</el-checkbox>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="warning" @click="closeDialog" round class="large-warning" :disabled="!readCheck">确定</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'DialogWarn',
	data () {
		return {
			readCheck: false
		}
	},
	props: ['openNotice'],
	computed: {
		dialogVisible: {
			get () {
				return this.openNotice
			},
			set (val) {
				this.$emit('update:openNotice', val)
			}
		},
	},

	methods: {
		closeDialog () {
			this.dialogVisible = false
			this.$parent.getProject()

		}
	},

}
</script>

<style scoped lang="scss">
.reading-main {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0 30px;
	p {
		font-size: 16px;
		margin: 0px 0 10px;
		text-align: left;
	}
}
</style>
